module.exports = __webpack_public_path__ + "media/theme/itunes__tutorial--5-bc7fadb0.png";